// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"f50bfe9d","316":"75079d8e"}[chunkId] + ".js";
};